module.exports = __webpack_public_path__ + "45aa7a15ef01d541ed9a6cccce69db87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/18_CC_V_TrainEngine.png
// module id = 119
// module chunks = 0